import React from "react";
import {
  FormControl,
  Select,
  MenuItem,
  TextField,
  Typography,
  FormHelperText,
  FormControlLabel,
  Radio,
  RadioGroup,
  Checkbox,
  Switch,
  Button,
  IconButton,
  Box,
  Tooltip,
  Autocomplete,
  Modal,
  Paper,
} from "@mui/material";
import { isFieldVisible, validateForm } from "./formUtils";
import formConfig from "./formConfig";

const TermsTiming = ({
  formData,
  setFormData,
  formMode,
  errors,
  setErrors,
  handleChange,
  currentDate,
}) => {
  const handleTextChange = (e) => {
    handleChange(e);
  };

  return (
    <>
      <div className="tab-pane active">
        <div className="row g-3">
          {isFieldVisible(
            "responseDeadline",
            formData.instrument,
            formConfig
          ) && (
            <div className="col-md-4">
              <FormControl
                fullWidth
                disabled={formMode === "view"}
                error={!!errors.responseDeadline}
              >
                <Typography variant="body2">
                  Response Deadline for banks
                </Typography>
                <TextField
                  name="responseDeadline"
                  type="date"
                  value={formData.responseDeadline || currentDate}
                  onChange={handleChange}
                  size="small"
                  sx={{ backgroundColor: "white" }}
                  inputProps={{ "aria-label": "Response Deadline" }}
                  disabled={formMode === "view"}
                />
                {errors.responseDeadline && (
                  <FormHelperText>{errors.responseDeadline}</FormHelperText>
                )}
              </FormControl>
            </div>
          )}
          {isFieldVisible(
            "preferredFinancingRateType",
            formData.instrument,
            formConfig
          ) && (
            <div className="col-md-4">
              <FormControl
                fullWidth
                disabled={formMode === "view"}
                error={!!errors.responseDeadline}
              >
                <Typography variant="body2">
                  Preferred Financing Rate Type
                </Typography>
                <TextField
                  name="preferredFinancingRateType"
                  value={formData.preferredFinancingRateType || ""}
                  onChange={handleChange}
                  size="small"
                  sx={{ backgroundColor: "white" }}
                  placeholder="e.g., Fixed, Variable"
                  inputProps={{ "aria-label": "Preferred Financing Rate Type" }}
                  disabled={formMode === "view"}
                />
                {errors.preferredFinancingRateType && (
                  <FormHelperText>
                    {errors.preferredFinancingRateType}
                  </FormHelperText>
                )}
              </FormControl>
            </div>
          )}
          {isFieldVisible(
            "maximumAcceptableCharges",
            formData.instrument,
            formConfig
          ) && (
            <div className="col-md-4">
              <FormControl
                fullWidth
                disabled={formMode === "view"}
                error={!!errors.maximumAcceptableCharges}
              >
                <Typography variant="body2">
                  Maximum Acceptable Charges (% or absolute)
                </Typography>
                <TextField
                  name="maximumAcceptableCharges"
                  value={formData.maximumAcceptableCharges || ""}
                  onChange={handleChange}
                  size="small"
                  sx={{ backgroundColor: "white" }}
                  placeholder="e.g., 1.5% or $500"
                  inputProps={{ "aria-label": "Maximum Acceptable Charges" }}
                  disabled={formMode === "view"}
                />
                {errors.maximumAcceptableCharges && (
                  <FormHelperText>
                    {errors.maximumAcceptableCharges}
                  </FormHelperText>
                )}
              </FormControl>
            </div>
          )}
          {isFieldVisible(
            "additionalComments",
            formData.instrument,
            formConfig
          ) && (
            <div className="col-md-4">
              <FormControl
                fullWidth
                disabled={formMode === "view"}
                error={!!errors.additionalComments}
              >
                <Typography variant="body2">
                  Additional Comments / Clarifications
                </Typography>
                <textarea
                  id="additionalComments"
                  className="form-control"
                  rows="3"
                  name="additionalComments"
                  value={formData.additionalComments}
                  onChange={handleChange}
                  disabled={formMode === "view"}
                />
                {errors.additionalComments && (
                  <FormHelperText>{errors.additionalComments}</FormHelperText>
                )}
              </FormControl>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default TermsTiming;
